module.exports = __webpack_public_path__ + "static/media/clear-icon-outline.f39939fb.svg";